import { render, staticRenderFns } from "./phone-wrap.vue?vue&type=template&id=78f8121e&scoped=true&"
import script from "./phone-wrap.vue?vue&type=script&lang=js&"
export * from "./phone-wrap.vue?vue&type=script&lang=js&"
import style0 from "./phone-wrap.vue?vue&type=style&index=0&id=78f8121e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78f8121e",
  null
  
)

export default component.exports